export type AmplitudeEnvironment = 'staging' | 'prod';

export const AmplitudeApiKey: Record<AmplitudeEnvironment, string> = {
  staging: '18fda9ac22786af09a50e662103d4680',
  prod: '4affa0e46338ec483067c1c778e76e05',
};
